import { render, staticRenderFns } from "./fulfilGiveFreeFreightEdit.vue?vue&type=template&id=15054a50&"
import script from "./fulfilGiveFreeFreightEdit.vue?vue&type=script&lang=js&"
export * from "./fulfilGiveFreeFreightEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports